<template>
    <div>
        <div>
            <el-form :model="employee" :label-position="'right'" label-width="50px" >
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="姓名">
                            <el-input v-model="employee.name"
                                      placeholder="请输入姓名"
                                      style="width:200px"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="电话">
                            <el-input v-model="employee.phone"
                                      placeholder="无电话"
                                      style="width: 200px"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="角色">
                            <el-select v-model="employee.new_role"
                                       placeholder="请选择"
                                       multiple
                                       clearable
                                       style="width: 200px">
                                <el-option
                                        v-for="item in roles"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="状态">
                            <el-select v-model="employee.status"
                                       placeholder="请选择"
                                       style="width: 200px">
                                <el-option
                                        v-for="item in status_type"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class=" text-right">
            <el-button type="primary" @click="handleStoreEmployee">确 定</el-button>
        </div>

    </div>
</template>

<script>
    export default {
        name: "Dialog_StoreEmployee",
        data () {
            return {
                employee:{
                    name:'',
                    phone:'',
                    new_role:[],
                    status:'active'
                },
                button_loading:false,
                status_type:[
                    {
                        id:'active',
                        name:'在职'
                    },{
                        id:'cancel',
                        name:'离职'
                    }
                ],
                roles:[
                    {
                        id:'teacher',
                        name:'老师'
                    },{
                        id:'headTeacher',
                        name:'班主任'
                    }
                ]
            };
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleStoreEmployee(){
                this.button_loading=true;
                this.$wApi.send(this.$parentInfo.path, 'store_employee', {
                    'employee': this.employee,
                });
            }
        }
    }
</script>

<style scoped>

</style>